"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const getTimeCounts = countdown => {
  if (countdown <= 0) {
    return [0, 0, 0, 0];
  }
  const days = Math.floor(countdown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(countdown % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  const minutes = Math.floor(countdown % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(countdown % (1000 * 60) / 1000);
  return [days, hours, minutes, seconds];
};
const useCountdown = targetTime => {
  const countdownTime = new Date(targetTime).getTime();
  if (!countdownTime) {
    throw new Error('Invalid target time is provided!');
  }
  const [countdown, setCountdown] = (0, _react.useState)(countdownTime - new Date().getTime());
  (0, _react.useEffect)(() => {
    const interval = setInterval(() => {
      setCountdown(countdownTime - new Date().getTime());
    }, 1000);
    return () => clearInterval(interval);
  }, [countdownTime]);
  return getTimeCounts(countdown);
};
var _default = exports.default = useCountdown;